<template>

    <div class="page">
        <SidebarBody/>
        <BorrowHistoryBody/>
    </div>
    
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import SidebarBody from "@/components/dashboard/SidebarBody.vue";
  import BorrowHistoryBody from "@/components/dashboard/BorrowHistoryBody.vue";
  
  export default defineComponent({
    name: "BorrowHistoryView",
    components: {
      SidebarBody,
      BorrowHistoryBody
    },
  });
  </script>
  